<!-- ***************************************************************************************************************************** -->
<!-- Form Div for Courses Explorer/Prerequisites -->
<tool-form formTitle="FA Filter">
  <form
    [formGroup]="financialAidForm"
    (ngSubmit)="financialAidFormSubmit()"
    class="form-content"
  >
    <!-- Year Dropdown Checkbox  -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select Year</mat-label>
      <mat-select
        (openedChange)="yearMultiSelectChange($event)"
        [formControl]="yearChosen"
        multiple
        required
      >
        <mat-option
          #allSelectedYears
          (click)="toggleAllYearsSelection(); allYearsClicked()"
          [value]=""
          >All Years
        </mat-option>
        <mat-option
          [disabled]="clickedAllYears"
          *ngFor="let year of yearList"
          [value]="year"
          >{{ year }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="isYearsEmpty">{{ getErrorMessage() }}</mat-error>
    </mat-form-field>

    <!-- Student Group Dropdown -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select Student Type</mat-label>
      <mat-select
        (openedChange)="studentGroupMultiSelectChange($event)"
        [formControl]="studentGroupChosen"
        multiple
        required
      >
        <mat-option
          #allSelectedStudentGroup
          [value]=""
          (click)="toggleAllStudentGroupSelection(); allStudentGroupClicked()"
          >All Student Group</mat-option
        >
        <mat-option
          [disabled]="clickedAllStudentGroup"
          *ngFor="let group of studentGroupList"
          [value]="group"
          >{{ group }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="isStudentGroupEmpty">{{ getErrorMessage() }}</mat-error>
    </mat-form-field>

    <!-- Fund Source Dropdown -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select Fund Sources</mat-label>
      <mat-select
        (openedChange)="fundSourceMultiSelectChange($event)"
        [formControl]="fundSourceChosen"
        multiple
        required
      >
        <mat-option
          #allSelectedFundSource
          (click)="toggleAllFundSourceSelection(); allFundSourceClicked()"
          value=""
          >All Fund Source</mat-option
        >
        <mat-option
          [disabled]="clickedAllFundSource"
          *ngFor="let source of fundSourceList"
          [value]="source"
          >{{ source }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="isFundSourceEmpty">{{ getErrorMessage() }}</mat-error>
    </mat-form-field>

    <!-- Fund Type Dropdown -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select Fund Types</mat-label>
      <mat-select
        (openedChange)="fundTypeMultiSelectChange($event)"
        [formControl]="fundTypeChosen"
        multiple
        required
      >
        <mat-option
          #allSelectedFundType
          (click)="toggleAllFundTypeSelection(); allFundTypeClicked()"
          value="All"
          >All Fund Type</mat-option
        >
        <mat-option
          [disabled]="clickedAllFundType"
          *ngFor="let option of fundTypeOption"
          [value]="option.code"
          matTooltip="{{ option.desc }}"
          matTooltipPosition="right"
          matTooltipClass="tooltip"
        >
          {{ option.code }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="isFundTypeEmpty">{{ getErrorMessage() }}</mat-error>
    </mat-form-field>

    <!-- Submit Button -->
    <tool-form-action-button
      text="Submit"
      [disabled]="disabledSubmitButton()"
      (onClick)="closeDialog()"
    ></tool-form-action-button>

    <!-- Export Button -->
    <tool-form-action-button
      *ngIf="showExportBtn"
      type="button"
      text="Export"
      (onClick)="exportData()"
    ></tool-form-action-button>
  </form>
</tool-form>
